import { RANKING_SIZE } from "./RankingSystem";
import { usePhasingContext } from "./phasing";

export const shouldDisplayRankingLabel = (ranking: number | undefined) => {
  const { areDestinationsInVotingPhase } = usePhasingContext();

  return !!(ranking && ranking <= RANKING_SIZE && areDestinationsInVotingPhase())
};
